import React, { useState, useEffect, useContext } from "react";
import "./RefinancingCarLoan.css";
import {
  Typography,
  useMediaQuery,
  Tooltip,
  tooltipClasses,
  styled,
  ClickAwayListener,
} from "@mui/material";
import StepOne from "./Steps/StepOne/StepOne.jsx";
import { Link } from "react-router-dom";
import Collaborators from "./Collaborators/Collaborators.jsx";
import StepTwo from "./Steps/StepTwo/StepTwo.jsx";
import SideBar from "./SideBar/SideBar.jsx";
import StepThree from "./Steps/StepThree/StepThree.jsx";
import StepFour from "./Steps/StepFour/StepFour.jsx";
import StepFive from "./Steps/StepFive/StepFive.jsx";
import StepSix from "./Steps/StepSix/StepSix.jsx";
import FAQ from "./FAQ/FAQ.jsx";
import PreQualify from "./PreQualify/PreQualify.jsx";
import {
  getRefinancingLoanData,
  refinancingCarLoanData,
} from "./refinancingCarLoanData.js";
import MoreLikeThis from "./MoreLikeThis/MoreLikeThis.jsx";
import MetadataContext from "../../../Pages/MetadataContext.js";

const RefinancingCarLoan = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");
  const [focusedStepId, setFocusedStepId] = useState("step-one");
  const [showAll, setShowAll] = useState(false); // State to manage visibility of all
  const [openDiscloser, setOpenDiscloser] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  // useEffect for scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is greater than 36rem (576px * 36)
      if (window.scrollY > 35 * 16 && !showSidebar) {
        setShowSidebar(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showSidebar]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handeDiscloserTooltipClose = () => {
    setOpenDiscloser(false);
  };

  const handeDiscloserTooltipOpen = () => {
    setOpenDiscloser(true);
  };

  // Toggle showAll state
  const toggleShowAll = () => {
    setShowAll((prev) => !prev);
  };

  const handleStepsLinks = (id) => {
    setFocusedStepId(id);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { setMetadata } = useContext(MetadataContext);

  useEffect(() => {
    setMetadata({
      pageTitle: "Calculate Car Loan Refinancing Options | Minemi.ai",
      pageDescription:
        "Minemi.ai’s refinancing calculator provides you with insights on how to reduce interest rates and payments. Refinance your car loan today",
      pageKeywords:
        "car loan refinancing calculator,car refinance calculator,auto loan refinance calculator",
      canonicalUrl:
        "https://minemi.ai/calculators/refinancing-calculators/refinancing-car-loan-calculator",
    });
  }, [setMetadata]);

  const advertiserData = (
    <div>
      <Typography>
        Minemi partners with trusted lenders, and we may receive compensation
        when you click on links or take action on their site. However, this does
        not affect our evaluations or ratings. Our opinions are our own.
      </Typography>
    </div>
  );

  return (
    <>
      <div id="page_container" className="">
        <section className="personal_loan__page  gap-lg-4 gap-xl-5">
          <section id="get_personal_loan__container" className=" ">
            <section className="py-2">
              <p className="heder_pages_links bg-transparent links ">
                <Link
                  to="/"
                  underline="hover"
                  className="bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Home
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Calculators
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  to="/calculators/refinancing-calculators"
                  underline="hover"
                  className="d-none d-md-inline bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Refinance Calculators
                </Link>
                &nbsp;
                <span
                  className="d-none d-md-inline bg-transparent ps-1 px-1 "
                  style={{
                    color: "#59266D",
                    fontFamily: "'Archivo', sans-serif",
                    fontWeight: 700,
                  }}
                >
                  &gt;
                </span>
                &nbsp;
                <Link
                  underline="hover"
                  className="d-none d-md-inline fw-bold bg-transparent archivo"
                  style={{
                    fontSize: isSmallScreen ? 13 : 16,
                    color: "#59266d",
                    cursor: "pointer",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  Refinancing a Car Loan in 6 Steps
                </Link>{" "}
              </p>
              {getRefinancingLoanData &&
                getRefinancingLoanData.map((item, index) => (
                  <div
                    key={index}
                    className="contents bg-transparent mt-3 my-lg-4"
                  >
                    <div className=" mt-4 mt-lg-5 ">
                      <div id="advertiser__discloser">
                        <ClickAwayListener
                          onClickAway={handeDiscloserTooltipClose}
                        >
                          <div className="w-auto">
                            <LightTooltip
                              arrow
                              open={openDiscloser}
                              title={<div>{advertiserData}</div>}
                            >
                              <div>
                                <Link
                                  underline="hover"
                                  style={{
                                    fontSize: 13,
                                    lineHeight: "20px",
                                    fontFamily: "'Archivo', sans-serif",
                                  }}
                                  onClick={handeDiscloserTooltipOpen} // Only this triggers tooltip to open
                                >
                                  Advertiser discloser
                                </Link>
                              </div>
                            </LightTooltip>
                          </div>
                        </ClickAwayListener>
                      </div>

                      <div className="content_heading d-flex flex-column align-items-start mt-2">
                        <Typography
                          className="bg-transparent archivo fw-bold"
                          sx={{
                            fontSize: {
                              xs: "32px",
                              sm: "35.4312px",
                              md: "40.2752px",
                              lg: "53.1927px",
                            },
                            lineHeight: {
                              xs: "38px",
                              sm: "42.0745px",
                              md: "47.8268px",
                              lg: "63.1663px",
                            },
                            letterSpacing: "0.04px",
                            textAlign: "start",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                        >
                          {item.heading}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 16,
                            lineHeight: "24px",
                            letterSpacing: "0.08px",
                            fontFamily: "'Archivo',sans-serif",
                          }}
                          className="sub-heading bg-transparent my-2 archivo"
                        >
                          {item.subHeading}
                        </Typography>
                      </div>

                      <div>
                        <img
                          src="https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/refinance-auto-loan-1738390834573.webp"
                          alt={item.heading}
                          className="hero-img"
                          loading="lazy"
                        />
                      </div>
                      <div className="notice rounded">
                        <Typography
                          sx={{
                            fontSize: "11.008px",
                            lineHeight: "16.512px",
                            letterSpacing: "0.64px",
                            textAlign: "start",
                            // color: "#ffffff",
                            // color: "#000",
                            color: "#8A8A8A",
                            fontFamily: "'Archivo', sans-serif",
                          }}
                          className="notic_text bg-transparent archivo  p-2 my-3"
                        >
                          {item.notice}
                        </Typography>
                      </div>
                    </div>
                    <div id="updation_content" className="mt-4">
                      <div className="d-flex">
                        <p className="updation_heading archivo">
                          {item.updationText}{" "}
                          <span className="archivo">
                            &nbsp;{item.updateTime}
                          </span>
                        </p>
                      </div>
                      <div>
                        <Collaborators />
                      </div>
                    </div>
                  </div>
                ))}
            </section>
            <section id="seven_steps_to_get_loan" className="">
              <div className="d-flex gap-3 gap-md-5 justify-content-between">
                <div id="steps_container" className="">
                  <section>
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "1px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        fontFamily: "'Archivo', sans-serif",
                      }}
                    >
                      Steps to Refinance Your Car Loan
                    </Typography>
                    <div className="steps-container mt-3">
                      {refinancingCarLoanData &&
                        refinancingCarLoanData
                          .slice(0, showAll ? refinancingCarLoanData.length : 5)
                          .map((item, index) => (
                            <div
                              key={index}
                              className={`stepsToGetLone steps_link ${
                                focusedStepId === item.id ? "focus_on" : ""
                              }`}
                              onClick={() => {
                                handleStepsLinks(item.id);
                              }}
                            >
                              <p className="archivo m-0">
                                <Link
                                  href={`#${item.id}`}
                                  underline="hover"
                                  sx={{ color: "#59266d", cursor: "pointer" }}
                                >
                                  {index + 1}. {item.stepName}
                                </Link>
                              </p>
                            </div>
                          ))}
                      <button
                        onClick={toggleShowAll}
                        className="show-more-btn archivo mt-2"
                      >
                        {showAll ? "Hide" : "Show More"}
                      </button>
                    </div>
                  </section>
                  <section className="steps-sections mt-3">
                    <div id="step-one">
                      <StepOne />
                    </div>
                    <div id="step-two">
                      <StepTwo />
                    </div>
                    <div id="step-three">
                      <StepThree />
                    </div>
                    <div id="step-four">
                      <StepFour />
                    </div>
                    <div id="step-five">
                      <StepFive />
                    </div>
                    <div id="step-six">
                      <StepSix />
                    </div>
                  </section>
                  <section className="mt-1">
                    <FAQ />
                  </section>
                  {/* <section>
                    <Authors />
                  </section> */}
                </div>
              </div>
            </section>
          </section>
          <aside
            id="side_bar__container"
            className={`d-none d-md-block ${
              showSidebar ? "show-sidebar" : "hide-sidebar"
            }`}
          >
            <div className={`side_bar `}>
              <SideBar />
            </div>
          </aside>
        </section>
        <section id="check_pre_qualify__container" className="w-100 pt-4">
          <PreQualify />
        </section>
        <section className="w-100">
          <MoreLikeThis />
        </section>
      </div>
    </>
  );
};

export default RefinancingCarLoan;
